/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { MyTaskRes } from '../models/my-task-res';

@Injectable({
  providedIn: 'root',
})
export class MyTaskService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation apiMytaskAllGet
   */
  static readonly ApiMytaskAllGetPath = '/api/mytask/all';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMytaskAllGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMytaskAllGet$Response(params?: {
  }): Observable<StrictHttpResponse<Array<MyTaskRes>>> {

    const rb = new RequestBuilder(this.rootUrl, MyTaskService.ApiMytaskAllGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<MyTaskRes>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiMytaskAllGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMytaskAllGet(params?: {
  }): Observable<Array<MyTaskRes>> {

    return this.apiMytaskAllGet$Response(params).pipe(
      map((r: StrictHttpResponse<Array<MyTaskRes>>) => r.body as Array<MyTaskRes>)
    );
  }

}
